module.exports = __webpack_public_path__ + "static/icon-f7f2c9754a07f0f1fed58495546914f3.png";